import { ClientOrder } from '../../models/clientOrder';

export function getClientOrderReference(
  order: Pick<ClientOrder, 'id' | 'clientOrderNumber'> | null | undefined
): string {
  if (!order) return '#';
  if (order.clientOrderNumber != null && Number(order.clientOrderNumber) >= 1) {
    return `#${Number(order.clientOrderNumber)}`;
  }
  if (order.id) return `${order.id.substring(0, 8)}`;
  return '#';
}
